import React, { useState, useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../context/AuthContext';
import './Admin.css';
import BannerFormModal from '../../components/admin/BannerFormModal'; // Yeni modal bileşeni
import ConfirmationModal from '../../components/support/ConfirmationModal';
const API_URL = process.env.REACT_APP_API_URL;

const BannerManagementPage = () => {
  const { t } = useTranslation();
  const { token } = useAuth();
  
  const [banners, setBanners] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedBanner, setSelectedBanner] = useState(null);
const [bannerToDelete, setBannerToDelete] = useState(null);
  const fetchBanners = useCallback(async () => {
    if (!token) return;
    try {
      setLoading(true); setError('');
      const response = await fetch(`${API_URL}/api/admin/banners`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (!response.ok) throw new Error(t('error_fetch_banners', 'Banner listesi alınamadı.'));
      const data = await response.json();
      setBanners(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [token, t]);

  useEffect(() => {
    fetchBanners();
  }, [fetchBanners]);
  
  const openAddModal = () => {
      setSelectedBanner(null);
      setIsModalOpen(true);
  };
  
  const openEditModal = (banner) => {
      setSelectedBanner(banner);
      setIsModalOpen(true);
  };

  const handleModalSave = () => {
      setIsModalOpen(false);
      fetchBanners(); 
  };
const openDeleteModal = (banner) => {
      setBannerToDelete(banner);
  };

 
  const handleDeleteBanner = async () => {
      if (!bannerToDelete) return;
      try {
          const response = await fetch(`${API_URL}/api/admin/banners/${bannerToDelete.id}`, {
              method: 'DELETE',
              headers: { 'Authorization': `Bearer ${token}` }
          });
          const data = await response.json();
          if (!response.ok) {
              throw new Error(t(data.messageKey) || t('error_delete_banner', 'Banner silinemedi.'));
          }
          alert(t(data.messageKey || 'success_banner_deleted', 'Banner başarıyla silindi.'));
          setBannerToDelete(null); // Modalı kapat
          fetchBanners(); // Listeyi yenile
      } catch (err) {
          alert(err.message);
          setBannerToDelete(null);
      }
  };
  const formatDate = (dateString) => {
    if (!dateString) return '-';
    return new Date(dateString).toLocaleDateString();
  };

  return (
    <>
      <div className="page-container admin-dashboard">
        <div className="page-header modern">
            <h1>{t('banner_management', 'Banner Yönetimi')}</h1>
            <button className="add-user-btn-modern" onClick={openAddModal}>
                <i className="fas fa-plus"></i> {t('add_new_banner', 'Yeni Banner Ekle')}
            </button>
        </div>
        
        <div className="admin-table-container">
          <table className="admin-table">
            <thead>
              <tr>
                <th>{t('title')}</th>
                <th>{t('status')}</th>
                <th>{t('start_date')}</th>
                <th>{t('end_date')}</th>
                <th>{t('actions')}</th>
              </tr>
            </thead>
            <tbody>
              {loading && <tr><td colSpan="5" className="table-row-message">{t('loading_banners', 'Bannerlar yükleniyor...')}</td></tr>}
              {error && <tr><td colSpan="5" className="table-row-message error">{error}</td></tr>}
              {!loading && banners.map(banner => (
                <tr key={banner.id}>
                  <td>{banner.title}</td>
                  <td><span className={`status-badge ${banner.is_active ? 'status-active' : 'status-inactive'}`}>{t(banner.is_active ? 'active' : 'inactive')}</span></td>
                  <td>{formatDate(banner.start_date)}</td>
                  <td>{formatDate(banner.end_date)}</td>
                  <td>
                    <div className="action-buttons">
                        <button className="action-btn edit" onClick={() => openEditModal(banner)}>
                            <i className="fas fa-pencil-alt"></i> {t('edit')}
                        </button>
						 <button className="action-btn delete" onClick={() => openDeleteModal(banner)}>
                            <i className="fas fa-trash-alt"></i> {t('delete')}
                        </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {isModalOpen && (
          <BannerFormModal 
            isOpen={isModalOpen} 
            onClose={() => setIsModalOpen(false)}
            onSave={handleModalSave}
            banner={selectedBanner}
          />
      )}
     <ConfirmationModal
        isOpen={!!bannerToDelete}
        onClose={() => setBannerToDelete(null)}
        onConfirm={handleDeleteBanner}
        title={t('confirm_delete_banner_title', 'Bannerı Sil')}
        message={t('confirm_delete_banner_message', { title: bannerToDelete?.title })}
      />
    </>
  );
};
export default BannerManagementPage;